module.exports = __webpack_public_path__ + "img/input-email-icon.08f53023.svg";